module.exports = __webpack_public_path__ + "assets/lizhi2.6acc803a.svg";